import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import IndexPqr from 'src/views/Pages/Dashboard/Pqr/IndexPqr.vue';
import Manage from 'src/views/Pages/Dashboard/Pqr/Manage/Manage.vue';
import Pqr from 'src/views/Pages/Dashboard/Pqr/Pqr/Pqr.vue';
import PqrCreate from 'src/views/Pages/Dashboard/Pqr/Pqr/PqrCreate.vue';
import PqrEdit from 'src/views/Pages/Dashboard/Pqr/Manage/PqrEdit.vue';
import Reports from 'src/views/Pages/Dashboard/Pqr/Reports/Reports.vue';
import Clients from 'src/views/Pages/Dashboard/Pqr/Clients/Clients.vue';
import ClientsCreateEdit from 'src/views/Pages/Dashboard/Pqr/Clients/ClientsCreateEdit.vue';

const PqrRoutes = {
  path: 'pqrs',
  name: 'PQRS',
  component: IndexPqr,
  children: [
    {
      path: 'pqrs',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'PQR',
          component: Pqr,
          meta: {
            prefix_permission: 'pqrs_pqrs',
          },
        },
        {
          path: 'create',
          name: 'PQR',
          component: PqrCreate,
          meta: {
            prefix_permission: 'pqrs_pqrs',
          },
        },
      ],
    },
    {
      path: 'manages',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'PQR',
          component: Manage,
          meta: {
            prefix_permission: 'pqrs_pqrs',
          },
        },
        {
          path: 'edit',
          name: 'PQR',
          component: PqrEdit,
          meta: {
            prefix_permission: 'pqrs_pqrs',
          },
        },
      ],
    },
    {
      path: 'reports',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'PQR',
          component: Reports,
          meta: {
            prefix_permission: 'pqrs_pqrs',
          },
        },
      ],
    },
    {
      path: 'clients',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'PQR',
          component: Clients,
          meta: {
            prefix_permission: 'pqrs_clients',
          },
        },
        {
          path: 'create',
          name: 'PQR',
          component: ClientsCreateEdit,
          meta: {
            prefix_permission: 'pqrs_clients',
          },
        },
        {
          path: 'edit',
          name: 'PQR',
          component: ClientsCreateEdit,
          meta: {
            prefix_permission: 'pqrs_clients',
          },
        },
      ],
    },
  ],
};

export default PqrRoutes;
